import { render, staticRenderFns } from "./CustomTreeTable.vue?vue&type=template&id=15f38098&scoped=true"
import script from "./CustomTreeTable.vue?vue&type=script&lang=js"
export * from "./CustomTreeTable.vue?vue&type=script&lang=js"
import style0 from "./CustomTreeTable.vue?vue&type=style&index=0&id=15f38098&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f38098",
  null
  
)

export default component.exports